module.exports = __webpack_public_path__ + "img/reject-icon.30b12501.svg";